<template>
    <!-- resource bodies keep div markup: their paragraphs carry block HTML (div, ul) that a <p> cannot contain -->
    <div v-if="variant === 'resource'" class="paragraph">
        <a-dangerous-html :content="data.text" tag="div" />
    </div>
    <p v-else class="paragraph">
        <a-dangerous-html :content="data.text" tag="span" />
    </p>
</template>

<script setup lang="ts">
import ADangerousHtml from '@core/components/dangerous-html/dangerous-html.vue';
import type { BodyVariant, ParagraphData } from '@model/editor-js/blocks';

defineOptions({
    name: 'BlockParagraph',
});

defineProps<{
    id?: string;
    data: ParagraphData;
    variant: BodyVariant;
}>();
</script>

<style lang="pcss" scoped>
.variant-blog .paragraph {
    @mixin paragraph;
    margin-bottom: 8px;
}

.variant-tru .paragraph {
    @mixin paragraph;
    margin-bottom: 24px;
}

.variant-resource .paragraph,
.variant-legal .paragraph {
    margin-top: 16px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--av-fixed-primary);
}

.variant-event-about .paragraph {
    @mixin paragraph;
    color: var(--av-fixed-primary);
    margin-bottom: 24px;
}

.variant-event-compact .paragraph {
    @mixin paragraph;
    margin-bottom: 16px;
}
</style>
